// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__GeistSans_3a0388', '__GeistSans_Fallback_3a0388'"},"className":"__className_3a0388","variable":"__variable_3a0388"};